/**
 * Resolve page/site SEO meta for the active language.
 * Supports nested { en: { title, description, keywords }, tr: {...} }
 * and legacy flat { title, description, keywords }.
 * Missing language falls back to English, then first available entry.
 */
const resolveMeta = (meta, lang) => {
    const empty = { title: '', description: '', keywords: '' };
    if (!meta || typeof meta !== 'object') {
        return empty;
    }

    // Legacy flat shape
    if (meta.title !== undefined || meta.description !== undefined) {
        return {
            title: meta.title || '',
            description: meta.description || '',
            keywords: meta.keywords || '',
        };
    }

    const entry = meta[lang] || meta.en || Object.values(meta).find(
        (v) => v && typeof v === 'object' && (v.title !== undefined || v.description !== undefined)
    );

    if (!entry) {
        return empty;
    }

    return {
        title: entry.title || '',
        description: entry.description || '',
        keywords: entry.keywords || '',
    };
};

export default resolveMeta;
